import React from "react";
import {
  FaFacebook,
  FaGithub,
  FaHackerrank,
  FaInstagram,
  FaLinkedin,
  FaPhone,
  FaUpwork,
} from "react-icons/fa6";
import { BiLogoGmail } from "react-icons/bi";

export const Socials = () => {
  const socials = [
    {
      name: "upwork",
      icon: <FaUpwork  size={20} />,
      to: "https://www.upwork.com/freelancers/~016a9f0f83cdca7065",
    },
    {
      name: "github",
      icon: <FaGithub size={20} />,
      to: "https://github.com/ahmadkaleem47",
    },
    {
      name: "instagram",
      icon: <FaInstagram size={20} />,
      to: "https://www.instagram.com/_ahmadkaleem_?igsh=MW9jZ3Jhenp4eGRpdA==",
    },
    {
      name: "facebook",
      icon: <FaFacebook size={20} />,
      to: "https://www.facebook.com/share/Y5fazzq5nRaRwx2y/?mibextid=qi2Omg",
    },
    {
      name: "linkedin",
      icon: <FaLinkedin size={20} />,
      to: "https://www.linkedin.com/in/ahmad-kaleem-1128091b4?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },
    {
      name: "hacker",
      icon: <FaHackerrank size={[20]} />,
      to: "https://www.hackerrank.com/profile/ahmedkaleem815",
    },
  ];

  return (
    <div className="mt-1 pb-10 flex flex-col sm:justify-start sm:items-start items-center justify-center gap-3">
      <div className="flex flex-wrap justify-center sm:justify-start items-center gap-4">
        {socials.map((social) => {
          return (
            <a
              rel="noreferrer"
              href={social.to}
              target="_blank"
              className="p-2 border-2 text-white rounded-full border-btn transition-all ease-in-out duration-200 hover:scale-[0.95] hover:opacity-85 bg-btn"
            >
              {social?.icon}
            </a>
          );
        })}
      </div>
      <a
        href="mailto:ahmedkaleem815@gmail.com"
        className="flex justify-start items-center gap-3 text-sm text-secondary"
      >
        <BiLogoGmail size={20} />
        <span className="text-header">ahmedkaleem815@gmail.com</span>
      </a>
      <a
        href="tel:+923035368934"
        className="flex justify-start items-center gap-3 text-sm text-secondary"
      >
        <FaPhone size={20} />
        <span className="text-header">+92 303 5368934</span>
      </a>
    </div>
  );
};

export default Socials;
